<template>
  <div class="selectCustomerStyle">
    <v-select
      v-model="inputedValue"
      item-text="label"
      item-value="value"
      :items="items"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      :height="height"
      :no-data-text="$t('payment.payment_sale-payment-not-register')"
    >
    </v-select>
  </div>
</template>

<script>
import { paymentMethodUtil } from '@/util'

export default {
  components: {
    //
  },
  props: {
    value: {
      type: Object,
      require: false,
      default: () => ({})
    },
    height: {
      type: String,
      require: false,
      default: '32px'
    },
    isHideUnusedPaymentMethod: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    items: []
  }),
  async created() {
    await this.getPaymentMethodList()
  },
  methods: {
    async getPaymentMethodList() {
      const isHideUnusedPaymentMethod = this.isHideUnusedPaymentMethod
      const tmp = await paymentMethodUtil.getPaymentMethodIdNameList(
        isHideUnusedPaymentMethod
      )
      this.items = tmp.data
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.selectCustomerStyle {
  width: 100%;
}
</style>
